import React from 'react';
import { createRoot } from 'react-dom/client';
import JoinUsButton from './components/join_us_button/JoinUsButton';

document.addEventListener('DOMContentLoaded', () => {
  const buttonElement = document.getElementById('react-join-us-button');
  createRoot(
    buttonElement,
  ).render(
    <JoinUsButton />,
  );
});
